import { render } from "./AdminManagementList.vue?vue&type=template&id=a5d3ad1a&scoped=true"
import script from "./AdminManagementList.vue?vue&type=script&lang=js"
export * from "./AdminManagementList.vue?vue&type=script&lang=js"

import "./AdminManagementList.vue?vue&type=style&index=0&id=a5d3ad1a&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d3ad1a"]])

export default __exports__